import Vue from 'vue';
import Errors from '../classes/Errors';
import store from '../store';
import { gsap } from 'gsap';
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(Draggable);

Vue.component('story-settings-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            settings: store.settings,
            questionNumber: 1,
            settingsCompleted: false,
            houseType: null,
            location:null,
            swipeEvent: null,
            inQuestionTransition: false
        };
    },

    watch: {
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

        Vue.nextTick(() => {
        this.setDraggableContainer();
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        beforeEnter(el) {
            el.style.opacity = 0
        },
        enter(el, done) {
            var title = el.querySelector('.story-settings__title');
            var question = el.querySelector('.story-settings__question');
            var textInput = el.querySelector('.story-settings__input-text');
            var imagesLabels = el.querySelectorAll('.story-settings__image-label');
            var customDropdown = el.querySelectorAll('.custom-dropdown');

            const onComplete = () => {
                this.inQuestionTransition = false;
                done();
            }

            gsap.to(el, {opacity: 1, duration: 1, onComplete })
            gsap.fromTo(title, {translateY: 50, opacity: 0}, {translateY: 0, opacity: 1, duration: 1, delay: 0.5})
            gsap.fromTo(question, {translateY: 50, opacity: 0}, {translateY: 0, opacity: 1, duration: 1, delay: 0.7})

            gsap.fromTo(textInput, {translateY: 50, opacity: 0}, {translateY: 0, opacity: 1, duration: 1, delay: 0.9})
            
            gsap.fromTo(customDropdown, {translateY: 50, opacity: 0}, {translateY: 0, opacity: 1, duration: 1, delay: 0.9})

            gsap.fromTo(imagesLabels, {scale: 0.5, opacity: 0}, {scale: 1.1, opacity: 1, duration: 0.5, delay: 0.9, stagger: 0.2})
            gsap.fromTo(imagesLabels, {scale: 1.1}, {scale: 1, duration: 1, delay: 1.4, stagger: 0.2})
        },
        leave(el, done) {
            var imagesLabels = el.querySelectorAll('.story-settings__image-label');
            gsap.to(el, {opacity: 0, duration: 1, onComplete: done})
            gsap.fromTo(imagesLabels, {scale: 1, opacity: 1}, {scale: 0, duration: 0.5, opacity: 0, stagger: -0.2})
        },
        setDraggableContainer() {
            var D = document.createElement('div');
            var self = this;
            this.swipeEvent = Draggable.create(D, {
                type:'y',
                lockAxis : true ,
                trigger: this.$el,
                onDragEnd:function(){
                    var dataValue = self.$el.querySelector(".story-settings-block").dataset.value
                    if(this.getDirection("start") == "up" && dataValue) {
                        if(dataValue == 'day' || dataValue == 'night') {
                            self.completeSettings()
                        } else {
                            self.questionNumber += 1
                        }
                    }
                }
            });
        },

        nextQuestion() {
            if (this.inQuestionTransition) {
                return;
            }

            this.inQuestionTransition = true;
            console.log('Next question is triggered');
            console.log(this.settings);
            this.questionNumber += 1
        },

        completeSettings() {

            EventBus.$emit('fadeout-sound', ['menu01']);
            const iconHolder = this.$el.querySelector('.swipe-next__icon-holder')
            gsap.to(iconHolder, {scale: 0, opacity: 0, duration: 1})

            if ( window.location.pathname === '/' ){
                localStorage.setItem("settings", JSON.stringify(this.settings))

                this.settingsCompleted = true
                window.location = '/stories/story-1-intro';
            } else {
                localStorage.setItem("settings", JSON.stringify(this.settings))
                
                this.settingsCompleted = true
                location.reload();
            }
        },

        toggleDropdown(event) {
            let element = event.currentTarget;

            while (element = element.parentElement) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');

                    const dropdownOptionsContainer = element.querySelector('.dropdown__options-holder')
                    const dropdownOptionsHolder = element.querySelector('.dropdown__options')
                    const dropdownOptions = element.querySelectorAll('.dropdown__options-option')

                    if (element.classList.contains('dropdown--active')) {
                        gsap.fromTo(dropdownOptionsContainer, {height: 0}, {height: 'auto', duration: 0.3})
                        gsap.fromTo(dropdownOptionsHolder, {overflowY: 'hidden'}, {overflowY: 'scroll', delay: 0.3, duration: 0.3})
                        gsap.fromTo(dropdownOptions, {opacity: 0}, {opacity: 1, stagger: 0.1, duration: 0.3})
                    } else {
                        gsap.fromTo(dropdownOptions, {opacity: 1}, {opacity: 0, duration: 0.3})
                        gsap.fromTo(dropdownOptionsContainer, {height: 'auto'}, {height: 0, duration: 0.3})
                        gsap.fromTo(dropdownOptionsHolder, {overflowY: 'scroll'}, {overflowY: 'hidden', duration: 0})
                    }
                }
            }
        },

        setDropdownHousetype(event) {
            this.houseType = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.settings.house = value
        },

        setDropdownLocation(event) {
            this.location = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.settings.fireStartplace = value
        },
    }
});
